import type { ElementSettingMap } from "../SettingsPayload";

/**
 * 枠の表示名を決める。settings が正本で、無ければ図形名を使う。
 *
 * `PowerPoint.Shape.name` は書き換えない。アドインで付けた名前が PowerPoint 側の
 * 自動採番に上書きされ続けると、直せない不具合として体験されるため。逆に settings だけを
 * 正本にして初期値を空にすると、1,170 枠すべてに手で名前を付けることになり現実的でない。
 * そこで**図形名は表示の落とし先**として使う。settings へ写しはしない。写すと
 * 1,170 件の設定が生まれてファイルを膨らませ、かつ「人が名前を付けたか」が判別できなくなる。
 * 落とし込みで同じ見た目になるので、写す利点が無い。
 */
export function resolveElementName(
    elements: ElementSettingMap,
    uid: string,
    shapeName: string
): string {
    const own = elements[uid]?.name;
    if (own !== undefined && own.trim().length > 0) return own;
    return shapeName;
}
